import { render, staticRenderFns } from "./AdminModalForm.vue?vue&type=template&id=2eae1f20&scoped=true"
import script from "./AdminModalForm.vue?vue&type=script&lang=ts"
export * from "./AdminModalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae1f20",
  null
  
)

export default component.exports